import React from 'react'
import PropTypes from 'prop-types'
import focusable from '../../../src/components/Focusable/Focusable'
import FocusableDiv from '../../../src/components/FocusableDiv/FocusableDiv'
import FocusableButton from '../../../src/components/FocusableButton/FocusableButton'
import StationPassportTitle from '../../../src/components/StationPassportTitle/StationPassportTitle'
import stationImages from '../../assets/img/in-app-donations-show-poster.webp'
import tts from '../../../src/lib/TTS'
import * as UI from '../../lib/ui'
import ToggleSwitch from '../../../src/components/ToggleSwitch/ToggleSwitch'
import Spinner from '../../../src/components/Spinner/Spinner'
import { MONTHLY, ONETIME } from '../../../src/lib/ComcastBilling'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

const TOGGLER_OPTIONS = [
  { id: 'first-option', value: 'Monthly' },
  { id: 'second-option', value: 'One-Time' },
]

export const PREDEFINED = 'predefined'

class DefaultDonationAmounts extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: 'InAppDonationScreen',
      focusedComponent: 'donationAmountButton',
      spinnerVisible: true,
      donationFrequency: MONTHLY,
      donationAmounts: [],
      selectedAmountId: null,
    }

    this.donationAmountsObj = {}
    this.defaultFocusedAmountIndex = 1
    this.focusedAmountIndex = this.defaultFocusedAmountIndex
    this.learnMoreButtonRef = React.createRef()
    this.continueButtonRef = React.createRef()
    this.toggleRef = React.createRef()
    this.donationAmountsRef = []
  }

  componentDidMount() {
    UI.registerFocusableComponent({ screen: this.state.id })
    if (!this.isAmountDataEmpty(this.props.station.donation_campaign)) {
      this.setAmountDataObject()
    } else {
      //todo: implement error handling ?
    }

    tts.pushTextToRead(`${this.props.station.short_common_name} passport.`)
    tts.pushTextToRead(this.getPassportBenefitsDescription())
    tts.pushTextToRead(this.getPassportExtraInfo())

    googleAnalytics4.sendPageViewEvent('Donation Selection')
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.spinnerVisible && !this.state.spinnerVisible) {
      this.focusOnDonationAmountItem(this.focusedAmountIndex)
    }
    const { spinnerVisible, donationAmounts } = this.state
    if (spinnerVisible && donationAmounts) {
      if (this.donationAmountMutated(prevProps)) {
        this.setAmountDataObject()
      }
    }
  }

  setAmountDataObject = () => {
    const {
      monthly_amount_options: monthlyDonationAmounts,
      onetime_amount_options: oneTimeDonationAmounts,
    } = this.props.station.donation_campaign

    this.donationAmountsObj = this.getDonationAmounts({
      monthlyDonationAmounts,
      oneTimeDonationAmounts,
    })

    if (this.donationAmountsObj[MONTHLY].length) {
      this.setState({
        donationAmounts: this.donationAmountsObj[MONTHLY],
        spinnerVisible: false,
      })
    }
  }

  isAmountDataEmpty = (amountProps) => {
    const {
      monthly_amount_options: monthlyAmountData,
      onetime_amount_options: oneTimeAmountData,
    } = amountProps
    return monthlyAmountData.length === 0 && oneTimeAmountData.length === 0
  }

  getDonationAmounts({ monthlyDonationAmounts, oneTimeDonationAmounts }) {
    const donationAmounts = {
      [MONTHLY]: [...monthlyDonationAmounts],
      [ONETIME]: [...oneTimeDonationAmounts],
    }
    donationAmounts[MONTHLY].push({ id: 'custom-amount', amount: 'Other' })
    donationAmounts[ONETIME].push({ id: 'custom-amount', amount: 'Other' })

    for (let donationFrequency in donationAmounts) {
      const items = donationAmounts[donationFrequency].map((singleAmount) => {
        return {
          ...singleAmount,
          label:
            singleAmount.id !== 'custom-amount'
              ? `$${singleAmount.amount}${
                  donationFrequency === MONTHLY ? '/month' : ''
                }`
              : singleAmount.amount,
          tts:
            singleAmount.id !== 'custom-amount'
              ? `${singleAmount.amount} dollars ${
                  donationFrequency === MONTHLY ? 'per month' : ''
                }`
              : `Custom amount`,
        }
      })

      donationAmounts[donationFrequency] = items
    }

    return donationAmounts
  }

  donationAmountMutated = (prevProps) => {
    let dataMutated = false
    if (
      this.isAmountDataEmpty(prevProps.station.donation_campaign) &&
      !this.isAmountDataEmpty(this.props.station.donation_campaign)
    ) {
      dataMutated = true
    }
    return dataMutated
  }

  focusOnDonationAmountItem(amountItemIdex) {
    this.focusedAmountIndex = amountItemIdex
    this.donationAmountsRef[amountItemIdex].setFocus()
    tts.addTextToRead(
      `Focused on ${
        this.donationAmountsObj[this.state.donationFrequency][amountItemIdex]
          .tts
      } donation`
    )
  }

  onKeyEvent(key) {
    tts.stop()
    const focusedComponent = window.focusedComponent
    let handled = false

    if ('BACK' === key) {
      this.props.router.navigate(-1)
    }

    switch (focusedComponent.componentType) {
      case 'learnMoreButton':
        if (key === 'DOWN') {
          this.focusOnDonationFrequencyToggler()
        }
        handled = true
        break
      case 'donationFrequencyToggler':
        if (key === 'UP') {
          this.learnMoreButtonRef.current?.setFocus()
          tts.addTextToRead('Focused on learn more button')
        }
        if (key === 'DOWN' || key === 'ENTER') {
          this.focusOnDonationAmountItem(this.defaultFocusedAmountIndex)
        }
        handled = true
        break
      case 'donationAmountItem':
        if (key === 'DOWN') {
          if (!this.state.selectedAmountId) return
          this.continueButtonRef.current?.setFocus()
          tts.addTextToRead('Focused on continue button')
          handled = true
        }
        if (key === 'UP') {
          this.focusOnDonationFrequencyToggler()
          handled = true
        }

        if (key === 'LEFT') {
          if (this.donationAmountsRef[this.focusedAmountIndex - 1]) {
            this.focusedAmountIndex--
            this.focusOnDonationAmountItem(this.focusedAmountIndex)
            handled = true
          }
        }
        if (key === 'RIGHT') {
          if (this.donationAmountsRef[this.focusedAmountIndex + 1]) {
            this.focusedAmountIndex++
            this.focusOnDonationAmountItem(this.focusedAmountIndex)
            handled = true
          }
        }

        if (key === 'ENTER') {
          const selectedAmount =
            this.donationAmountsRef[this.focusedAmountIndex].props
          if (selectedAmount.id === 'custom-amount') {
            this.navigateToCustomAmountPage()
            return
          }

          this.setState({
            selectedAmountId: selectedAmount.id,
          })

          this.continueButtonRef.current?.setFocus()
          tts.addTextToRead('Focused on continue button')
          tts.pushTextToRead(
            `Selected ${
              this.donationAmountsObj[this.state.donationFrequency][
                this.focusedAmountIndex
              ].tts
            } donation`
          )

          handled = true
        }
        break
      case 'continueButton':
        if (key === 'UP') {
          this.focusOnDonationAmountItem(this.focusedAmountIndex)
        }
        handled = true
        break
      default:
        handled = false
    }

    return handled
  }

  navigateToLearnMorePage = () => {
    tts.pushTextToRead('Selected learn more button')
    this.props.router.navigate(`/learn-more`)
  }

  navigateToCustomAmountPage = () => {
    tts.pushTextToRead(
      `Selected ${
        this.donationAmountsObj[this.state.donationFrequency][
          this.focusedAmountIndex
        ].tts
      } donation`
    )
    this.props.router.navigate(
      `/in-app-donations/custom-amount-donation/${this.state.donationFrequency}`
    )
  }

  getPassportBenefitsDescription = () => {
    return `Support ${this.props.station.short_common_name} and get extended, on-demand access
            to your favorite PBS shows and local programs as a member
            benefit. Enjoy new and classic PBS series by streaming early
            releases or binge-watching on any device with Passport.`
  }

  getPassportExtraInfo = () => {
    return `To support ${this.props.station.short_common_name} with a tax-deductible donation
            and start watching Passport videos, select your donation amount:`
  }

  setAmountItemRefs = (element, index) => {
    this.donationAmountsRef[index] = element
  }

  focusOnDonationFrequencyToggler() {
    this.toggleRef.current?.setFocus()
    const actionKey =
      this.state.donationFrequency === MONTHLY ? 'right' : 'left'
    const nextDonationFrequency =
      this.state.donationFrequency === MONTHLY ? ONETIME : MONTHLY
    tts.addTextToRead(
      `Focused on donation type switch. Press ${actionKey} to switch to ${nextDonationFrequency} donation type`
    )
  }

  onToggle = () => {
    this.donationAmountsRef = []
    this.setState((prevState) => {
      const donationFrequencyToSelect =
        prevState.donationFrequency === ONETIME ? MONTHLY : ONETIME

      tts.addTextToRead(
        `Switching to ${donationFrequencyToSelect} donation type`
      )
      return {
        ...prevState,
        selectedAmountId: null,
        donationAmounts: this.donationAmountsObj[donationFrequencyToSelect],
        donationFrequency: donationFrequencyToSelect,
      }
    })

    this.focusedAmountIndex = this.defaultFocusedAmountIndex
  }

  executeDonationProcess = () => {
    const { donationFrequency, selectedAmountId } = this.state

    const selectedAmount = this.state.donationAmounts.filter(
      (da) => da.id === selectedAmountId
    )[0]

    this.props.executeDonationProcess({
      totalChargeAmount: selectedAmount.amount,
      donationFrequency,
      donationType: PREDEFINED,
    })
  }

  render() {
    return (
      <>
        <Spinner visible={this.state.spinnerVisible} />
        <div className="donation-container__passport">
          <div className="donation-container__image-container">
            <img src={stationImages} alt="shows-poster" />
          </div>
          <div>
            <StationPassportTitle
              className="donation-container__details-title"
              stationTitle={this.props.station.short_common_name}
            />
            <div className="donation-container__details-description">
              <p>{this.getPassportBenefitsDescription()}</p>
            </div>
            <div className="donation-container__details-learn-more">
              <FocusableButton
                id="learn-more"
                parent={this}
                componentType="learnMoreButton"
                ref={this.learnMoreButtonRef}
                className="donation-container__details-learn-more-btn"
                onClick={this.navigateToLearnMorePage}
              >
                Learn More
              </FocusableButton>
            </div>
          </div>
        </div>

        <div className="donation-container__donation-amounts">
          <div className="donation-container__donation-amounts-header">
            <div className="donation-container__extra-passport-information">
              {this.getPassportExtraInfo()}
            </div>
            <ToggleSwitch
              parent={this}
              ref={this.toggleRef}
              componentType="donationFrequencyToggler"
              onToggle={this.onToggle}
              options={TOGGLER_OPTIONS}
              defaultSelected={
                this.state.donationFrequency === MONTHLY
                  ? TOGGLER_OPTIONS[0].id
                  : TOGGLER_OPTIONS[1].id
              }
            />
          </div>
          <div className="donation-container__amounts">
            {this.state.donationAmounts.map((singleAmount, index) => (
              <FocusableDiv
                key={singleAmount.id}
                id={`${singleAmount.id}`}
                className={`donation-container__amount ${
                  this.state.selectedAmountId === singleAmount.id
                    ? 'selected'
                    : ''
                }`}
                parent={this}
                componentType={`donationAmountItem`}
                ref={(element) => this.setAmountItemRefs(element, index)}
              >
                {singleAmount.label}
              </FocusableDiv>
            ))}
          </div>
          <div className="donation-container__continue-donation">
            <FocusableButton
              id="continue"
              parent={this}
              componentType="continueButton"
              disabled={!this.state.selectedAmountId}
              ref={this.continueButtonRef}
              className="donation-container__continue-btn"
              onClick={this.executeDonationProcess}
            >
              <div className="donation-container__continue-text">Continue</div>
              <div className="donation-container__continue-arrow"></div>
            </FocusableButton>
          </div>
        </div>
      </>
    )
  }
}

DefaultDonationAmounts.propTypes = {
  station: PropTypes.shape({
    short_common_name: PropTypes.string,
    donation_campaign: PropTypes.shape({
      monthly_amount_options: PropTypes.array,
      onetime_amount_options: PropTypes.array,
    }),
  }),
  executeDonationProcess: PropTypes.func,
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
}
export default withRouter(focusable(DefaultDonationAmounts))
